import useScrollTriggerContext from '@contexts/scrollTriggerContext'
import theme, { fontSize, size } from '@styles/theme'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'

import GearIconButton from '@elements/GearIconButton'
import AppBarAvatar from '@elements/AppBarAvatar'
import NavTextField from '@elements/NavTextField'
import { Toolbar, Tabs } from '@mui/material'
import BaseAppBar from '@elements/BaseAppBar'
import { PiInfoBold } from 'react-icons/pi'
import StyledTab from '@elements/Tab'

const HomeToolbar = styled(Toolbar)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AppBarContainer = styled.div`
  position: fixed;
  top: 0;

  z-index: 100;
  width: 100%;
  
  border-bottom: 0.5px solid rgba(255,255,255,0.2);
  // background-color: rgba(0,0,0,1);
  ${theme.glassBackgruond(0.9)}
  will-change: transform;
  // transform: translate3d(0, 0, 0);
`

const HomeTopNav = ({ selectedItem, setSelectedItem }) => {
  const { scrollTrigger } = useScrollTriggerContext()
  const navigate = useNavigate()

  return (
      <AppBarContainer className={scrollTrigger ? 'animation__hide-top-nav' : 'animation__show-top-nav'}>
        {/* <Button
          style={{ borderRadius: '100px', position: 'absolute', top: size(15), width: size(20), zIndex: 10000, left: `calc(50% - ${size(10)})`, right: '0%', whiteSpace: 'nowrap' }}
          // className={scrollTrigger ? 'animation__hide-top-nav-check-new-posts' : 'animation__show-top-nav-check-new-posts'}
          variant='contained'>
          <PiArrowUpBold />&nbsp;Check new posts
        </Button> */}
        <BaseAppBar style={{ boxShadow: 'none' }}>
          <HomeToolbar>
            <AppBarAvatar />
            <NavTextField onClick={() => navigate('/about')}>
              {/* <div style={{ color: 'grey', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: fontSize('sm') }}><PiMagnifyingGlassBold fill='grey' size={size(1.6)} />&nbsp;&nbsp;Search Mandrake</div> */}
              <div style={{ color: 'grey', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: fontSize('sm') }}><PiInfoBold fill='grey' size={size(1.6)} />&nbsp;&nbsp;Mandrake App</div>
            </NavTextField>
              {/* <img style={{ height: size(3), width: size(3)}} src={logo} /> */}
            <GearIconButton style={{ visibility: 'hidden' }} />
          </HomeToolbar>
        </BaseAppBar>
        <Tabs
          slotProps={{ list: { sx: { display: 'flex', justifyContent: 'space-around', width: '100%', paddingLeft: size(1), paddingRight: size(1) } } }}
          onChange={(e, val) => setSelectedItem(val)}
          aria-label="home view tabs"
          value={selectedItem}>
          <StyledTab label='Discover' color={selectedItem === 0 ? 'white' : 'grey'} />
          <StyledTab label='Following' color={selectedItem === 1 ? 'white' : 'grey'} />
          <StyledTab label='Nearby' color={selectedItem === 2 ? 'white' : 'grey'} />
        </Tabs>
      </AppBarContainer>
  )
}

export default HomeTopNav
